import isNil from 'lodash/isNil';

import type { AppData } from '../../types/app_data';
import type { Step } from '../types/step';
import { StepCategory } from '../../types/app_data';

export const ReferralStep: Step = {
  // Ask referral source
  id: 'askReferral',
  pathname: '/referral',
  canShow: (appData: AppData) => {
    return !appData.isOnboardingLite && !!appData.featureData?.askReferralSource;
  },
  hasData: () => true,
  hasOwnData: (appData: AppData) => !isNil(appData.referralSource),
  category: () => StepCategory.Other,
};
